// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beEllq {
  position: relative;
  width: 100%;
  height: 400px;
  min-height: 100%;
  background-color: #fafafa !important;
  border: 1px solid var(--border-grey, #e6e6e6);
  border-radius: var(--radius-s, 4px);
  overflow: hidden;
  box-sizing: border-box;
}

.beEllq::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fafafa !important;
  z-index: 0;
  pointer-events: none;
}

.uOFkaL {
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: #fafafa !important;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-sm, 12px);
  font-weight: var(--font-weight-regular, 400);
  line-height: 22.4px;
  letter-spacing: 0%;
  z-index: 1;
}

.uOFkaL h1,
.uOFkaL h2,
.uOFkaL h3,
.uOFkaL h4,
.uOFkaL h5,
.uOFkaL h6 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-sm, 12px);
  line-height: 22.4px;
  letter-spacing: 0%;
  text-transform: uppercase;
}

.HIwnyy,
.l6g0Cl {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: #fafafa !important;
}

.PfGcuZ,
.fRHSp_ {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  color: var(--text-neutral-dark);
}

.terms-of-use {
  min-height: 100% !important;
  background-color: #fafafa !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/Onboarding/components/TermsOfUse/TermsOfUseContent/TermsOfUseContent.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,6CAA6C;EAC7C,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;EAME,iEAAiE;EACjE,6CAA6C;EAC7C,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;;EAEE,iEAAiE;EACjE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC","sourcesContent":[".termsOfUseContentWrapper {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  min-height: 100%;\n  background-color: #fafafa !important;\n  border: 1px solid var(--border-grey, #e6e6e6);\n  border-radius: var(--radius-s, 4px);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.termsOfUseContentWrapper::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fafafa !important;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.termsIframe {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: #fafafa !important;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-sm, 12px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 22.4px;\n  letter-spacing: 0%;\n  z-index: 1;\n}\n\n.termsIframe :global(h1),\n.termsIframe :global(h2),\n.termsIframe :global(h3),\n.termsIframe :global(h4),\n.termsIframe :global(h5),\n.termsIframe :global(h6) {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-sm, 12px);\n  line-height: 22.4px;\n  letter-spacing: 0%;\n  text-transform: uppercase;\n}\n\n.loadingContainer,\n.errorContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n  gap: 16px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  background-color: #fafafa !important;\n}\n\n.loadingText,\n.errorText {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  color: var(--text-neutral-dark);\n}\n\n:global(.terms-of-use) {\n  min-height: 100% !important;\n  background-color: #fafafa !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"termsOfUseContentWrapper": `beEllq`,
	"termsIframe": `uOFkaL`,
	"loadingContainer": `HIwnyy`,
	"errorContainer": `l6g0Cl`,
	"loadingText": `PfGcuZ`,
	"errorText": `fRHSp_`
};
module.exports = ___CSS_LOADER_EXPORT___;
